<template>
  <GBox class="contract-history-wrapper">
    <GText
      variant="subtitle-03"
      color="mid-grey-500"
    >
      Sözleşmelerim
    </GText>
    <GBox :mt="10">
      <GDataTable
        :is-loading="loading"
        :items="contractHistory"
        :headers="headers"
      >
        <template v-slot:status="{ row }">
          <GText>{{ row.readableStatus }}</GText>
          <GBox
            v-if="row.documentStatus.status === contractStatus.NOT_STARTED"
            :mt="10"
          >
            <GText
              variant="caption"
              v-for="(reviseReason, idx) in row.documentStatus.revisionReasons"
              :key="idx"
            >
              • {{ reviseReason }}
            </GText>
          </GBox>
        </template>
        <template v-slot:detail="{ row }">
          <GButton
            v-for="(file, idx) in row.files"
            :key="idx"
            class="contract-btn"
            outline
            fluid
            @click="onFileDownload(file)"
          >
            Görüntüle
          </GButton>
        </template>
      </GDataTable>
    </GBox>
  </GBox>
</template>

<script>
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import GButton from '@trendyol-js/grace/core/GButton';
import GDataTable from '@trendyol-js/grace/core/GDataTable';
import { SellerCenterSellerApiClient } from '@/apis';
import SupplierService from '@/services/SupplierService';
import ContractStatus from '@/enums/ContractStatus';
import account from '@/services/account';
import { remoteConfig } from '@/services';

const EMPTY_CONTRACT_SHOWN_STATUS = [ContractStatus.NOT_STARTED, ContractStatus.REVISED];
export const ANTALYA_CITY_ID = 7;
const CONTRACT_STATUS_MAP = {
  [ContractStatus.REVISED]: 'Revize Gerekiyor',
  [ContractStatus.NOT_STARTED]: 'Göndermeniz Bekleniyor',
  [ContractStatus.COMPLETED]: 'Onaylandı',
};

export default {
  name: 'ContractHistory',

  components: {
    GBox,
    GText,
    GDataTable,
    GButton,
  },

  data () {
    return {
      loading: false,
      contractHistory: [],
    };
  },

  computed: {
    headers () {
      return [
        { text: 'SÖZLEŞME ADI', key: 'readableContractName' },
        { text: 'STATÜ', key: 'status' },
        { text: 'DETAY', key: 'detail' },
      ];
    },

    contractStatus () {
      return ContractStatus;
    },
  },

  methods: {
    onFileDownload (file) {
      window.open(file);
    },

    hasAnyAntalyaCityInSellerAddresses (sellerAddressesObj) {
      const allAddresses = Object.values(sellerAddressesObj);

      if (allAddresses.length === 0) {
        return false;
      }

      return allAddresses.some(addresses => {
        return addresses.some(address => address.cityId === ANTALYA_CITY_ID);
      });
    },

    async getPhysicalContract () {
      try {
        const isMealSeller = SupplierService.isMeal();
        this.loading = true;
        const contractResponse = await SellerCenterSellerApiClient.get('seller/physical-contract', { hideSpinner: true });
        const contractStatus = contractResponse.documentStatus.status;

        if (EMPTY_CONTRACT_SHOWN_STATUS.includes(contractStatus)) {
          if (isMealSeller) {
            let sellerAddressResponse = {};

            try {
              sellerAddressResponse = await account.getAddressesV2({ hideErrorMessage: true });
            } catch (err) {
              if (err.response.status === 404) {
                sellerAddressResponse = {};
              } else {
                throw err;
              }
            }

            contractResponse.files = [
              this.hasAnyAntalyaCityInSellerAddresses(sellerAddressResponse)
                ? remoteConfig.getConfigValueByKey('MEAL_ANTALYA_AGREEMENT_LINK')
                : remoteConfig.getConfigValueByKey('MEAL_AGREEMENT_LINK'),
            ];
          } else {
            contractResponse.files = [
              remoteConfig.getConfigValueByKey('TRENDYOL_AGREEMENT_URL'),
            ];
          }
        }

        contractResponse.readableContractName = 'Trendyol Partner Sözleşmesi';
        contractResponse.readableStatus = CONTRACT_STATUS_MAP[contractStatus] || '---';

        this.contractHistory = [contractResponse];
      } finally {
        this.loading = false;
      }
    },
  },

  created () {
    this.getPhysicalContract();
  },
};
</script>

<style lang="scss" scoped>
.contract-history-wrapper {
  .contract-btn {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
</style>
